// extracted by css-extract-rspack-plugin
export default {"sizeFluid":"100%","cardChildren":"card-children__cardChildren___UUQsy"};